import { cloneDeep } from 'lodash';

/**
 * Generic function to handle reordering items in nested arrays
 * @param {Function} getValues - React Hook Form getValues function
 * @param {Function} setValue - React Hook Form setValue function
 * @param {Function} clearErrors - React Hook Form clearErrors function
 * @param {Object} params - Parameters for the reordering operation
 * @param {number} params.sectionIndex - Index of the section
 * @param {number} params.sourceIndex - Current index of the item to move
 * @param {number} params.destinationIndex - Target index for the item
 * @param {number} [params.questionIndex] - Index of parent question (for child questions)
 * @param {number} [params.childQuestionIndex] - Index of child question (for grandchild questions)
 */
const handleItemReordering = (getValues, setValue, clearErrors, params) => {
    const { sectionIndex, sourceIndex, destinationIndex, questionIndex, childQuestionIndex } = params;

    // Determine the path and get the current array
    let fieldPath;
    let errorPath;
    let currentValues;
    let targetArray;

    if (childQuestionIndex !== undefined) {
        // Grandchild question reordering
        fieldPath = `sections[${sectionIndex}].questions[${questionIndex}].questions[${childQuestionIndex}].questions`;
        errorPath = `sections[${sectionIndex}].questions[${questionIndex}].questions[${childQuestionIndex}].questions`;
        currentValues = getValues();
        targetArray = cloneDeep(
            currentValues.sections[sectionIndex].questions[questionIndex].questions[childQuestionIndex].questions,
        );
    } else if (questionIndex !== undefined) {
        // Child question reordering
        fieldPath = `sections[${sectionIndex}].questions[${questionIndex}].questions`;
        errorPath = `sections[${sectionIndex}].questions[${questionIndex}].questions`;
        currentValues = getValues();
        targetArray = cloneDeep(currentValues.sections[sectionIndex].questions[questionIndex].questions);
    } else {
        // Top-level question reordering
        fieldPath = `sections[${sectionIndex}].questions`;
        errorPath = `sections[${sectionIndex}].questions`;
        currentValues = getValues();
        targetArray = cloneDeep(currentValues.sections[sectionIndex].questions);
    }

    // Perform the reordering
    const [movedItem] = targetArray.splice(sourceIndex, 1);
    targetArray.splice(destinationIndex, 0, movedItem);

    // Update the form
    clearErrors(errorPath);
    setValue(fieldPath, targetArray, { shouldDirty: true, shouldValidate: false });
};

export default handleItemReordering;
